<div class="card card-primary card-outline style">
   <p class="style1">
        <b>{{name}}</b>
      </p>

      <div *ngFor="let c of output">

        <table class="table style">
        
        <tbody>
        
          <tr>
          <td style="width: 30%"><b>Date And Time :</b></td>
          <td>{{DateFormat(c.date_time)}}</td>
          </tr>
      
          <tr>
          <td><b>Product Id :</b></td>
          <td>{{c._id}}</td>
          </tr>

          <tr>
          <td><b>Product Name :</b></td>
          <td>{{c.product_name}}</td>
          </tr>

          <tr>
          <td><b>Manufacturer Name :</b></td>
          <td>{{c.manufacturer_name}}</td>
          </tr>

          <tr>
          <td><b>Quantity :</b></td>
          <td>{{c.qty}}</td>
          </tr>

          <tr>
          <td><b>Operator Name :</b></td>
          <td>{{c.operator_name}}</td>
          </tr>

          <tr>
          <td><b>Tinter Man Name :</b></td>
          <td>{{c.tinterman_name}}</td>
          </tr>

          <tr>
          <td><b>Supervisor Name :</b></td>
          <td>{{c.supervisor_name}}</td>
          </tr>
          
          <tr>
          <td><b>Machine Name :</b></td>
          <td>{{c.machine_name}}</td>
          </tr>

          <tr>
          <td><b>Entity :</b></td>
          <td>{{c.entity}}</td>
          </tr>

          <tr>
          <td><b>UOM Name :</b></td>
          <td>{{c.uom_name}}</td>
          </tr>
  

          
          
          <tr>
          <td><b>Start Time :</b></td>
          <td>{{c.start_time}}</td>
          </tr>

          <tr>
          <td><b>End Time :</b></td>
          <td>{{c.end_time}}</td>
          </tr>

          <tr>
          <td><b>Special Advice :</b></td>
          <td>{{c.special_advice}}</td>
          </tr>
      
        </tbody>
    </table>      

